import { ComponentChildren } from 'preact';
import { T, btnIcon } from '@/ui/tokens';
import { Icons, sized } from '@/ui/icons';

export function TopBar({
  title, sub, right, onBack,
}: {
  title: string;
  sub?: string;
  right?: ComponentChildren;
  onBack?: () => void;
}) {
  return (
    <div style={{
      padding: 'calc(var(--safe-top, 0px) + 18px) 20px 14px',
      display: 'flex', alignItems: 'center', gap: 12,
    }}>
      {onBack && (
        <button onClick={onBack} style={btnIcon} aria-label="Back">
          {sized(Icons.arrL, 18)}
        </button>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: 22, fontWeight: 700, color: T.text, letterSpacing: -0.5,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>{title}</div>
        {sub && (
          <div style={{ fontSize: 12, color: T.textDim, marginTop: 2,
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {sub}
          </div>
        )}
      </div>
      {right}
    </div>
  );
}
